import manageGroupTemplate from './manageGroup.template.html';
import '../../accountAdmin.css';

/*****************************************************************************
 * manageGroup */
/**
 * @ngdoc   component
 * @module  books.ui.accountAdmin
 * @name    books.ui.accountAdmin.component:manageGroup
 *
 * @param  group              Group being modified
 * @param  incomeExpenseOnly  Bool Flag to display only income and expense accounts
 *
 * @description Used to manage existing account groups or create new account
 * groups in the account admin app.
 *****************************************************************************/
export const manageGroupComponent = {
  template: manageGroupTemplate,
  controller: manageGroupController,
  bindings: { group: '<', incomeExpenseOnly: '<' }
}

/*****************************************************************************
 * Controller: manageGroupController
 *
 * Controls manageGroup component
 *****************************************************************************/
/* @ngInject */ function manageGroupController(
  $scope,
  $location,
  $q,
  Accounts,
  Alert,
  ShuttleService,
  UserAgent,
  $routeParams,
  AccountSettings,
  AccountType,
  BusyScreen,
  Tools
) {
  /** Self Reference. */ var mThis = this;
  /** GroupID of group being changed */ var mGroupID = Number(
    $routeParams.groupID
  );
  /** non grouped accounts array */ mThis.nonGroupedAccounts = [];
  /** Validation object */ mThis.valOption = {};

  /*--------------------------------------------------------------*/
  /* This is set to an empty array so that we do not get an error */
  /* when adding groups to a new group using the shuttleList.     */
  /*--------------------------------------------------------------*/
  mThis.acctsInGroup = [];

  /*---------------------------------------------------------------*/
  /* If the user is on a mobile device, we need to enable the      */
  /* touch drag and drop feature on the drag handle. Only the drag */
  /* handle is set so that the user can scroll through the lists.  */
  /*---------------------------------------------------------------*/
  mThis.mobileDevice = UserAgent.isIOSDevice() || UserAgent.isAndroid();

  /***************************************************************************
   * cancel */
  /**
   * Called on the cancel button. Redirects back to the groups path.
   ***************************************************************************/
  mThis.cancel = function () {
    $location.path('/groups/');
  };

  /***************************************************************************
   * displayAccountName */
  /**
   * Format the name to be displayed in the shuttle list using the accountName
   * and the accountNumber.
   ***************************************************************************/
  mThis.displayAccountName = function (account) {
    var name = account.accountName ? account.accountName : '';
    var number = account.accountNumber
      ? ' (' + account.accountNumber + ')'
      : '';
    account.displayName = name + number;
    return name + number;
  };

  /***************************************************************************
   * removeInsertClass */
  /**
   * Called on drop. Removes the insert class from all elements.
   ***************************************************************************/
  function removeInsertClass() {
    /*--------------------------------------------------------*/
    /* The querySelectorAll returns a NodeList, not an array. */
    /* We need to use the forEach from the Array.prototype    */
    /* directly because the, while NodeList has the forEach   */
    /* function, it is not supported in all browsers.         */
    /*--------------------------------------------------------*/
    var elements = document.querySelectorAll('manage-account-group .insert');
    Array.prototype.forEach.call(elements, function (e) {
      e.classList.remove('insert');
    });
  }

  /***************************************************************************
   * saveGroup */
  /**
   * Saves the group.
   ***************************************************************************/
  mThis.saveGroup = function () {
    if (!mThis.valOption.validate()) return;
    /*---------------------------------------*/
    /* Get the list of account ID's and add  */
    /* them to the group object to be saved. */
    /*---------------------------------------*/
    var acctIDs = mThis.acctsInGroup
      ? mThis.acctsInGroup.map(function (a) {
          return a.accountID;
        })
      : null;
    mThis.group.acctIDs = acctIDs;

    BusyScreen.promise(
      Accounts.saveAccountGroup(mThis.group).then(
        function (groupID) {
          /*--------------------------------------*/
          /* Set the groupID and groupDescription */
          /* on each object for each of the lists */
          /*--------------------------------------*/
          mThis.nonGroupedAccounts.forEach(function (nga) {
            (nga.groupID = null), (nga.groupDescription = '');
          });
          mThis.acctsInGroup.forEach(function (aig) {
            (aig.groupID = groupID),
              (aig.groupDescription = mThis.group.description);
          });

          Alert.success(mThis.group.description + ' saved');
          AccountSettings.reloadGroups().then(function () {
            $location.path('/groups/');
          });
        },
        function (resp) {
          Alert.error(resp.parsedResponse.message(), mThis.group.description);
        }
      )
    );
  };

  /***************************************************************************
   * setAccountInfo */
  /**
   * Get the accounts that are in the group being changed.
   ***************************************************************************/
  function setAccountInfo() {
    /*------------------------------------*/
    /* Get only Administrative accounts   */
    /* that are either an Income/Expense. */
    /*------------------------------------*/
    var accounts = !mThis.incomeExpenseOnly
      ? AccountSettings.accounts
      : AccountSettings.accounts.filter(function (as) {
          return (
            Tools.isNaNZero(as.classID) &&
            (as.type == AccountType.EXPENSE || as.type == AccountType.REVENUE)
          );
        });

    /*---------------------------------------------*/
    /* Create the grouped and non grouped accounts */
    /* objects to be displayed in the DOM.         */
    /*---------------------------------------------*/
    accounts.filter(function (account) {
      if (mGroupID > 0 && account.groupID == mGroupID)
        mThis.acctsInGroup.push(account);

      if (!account.groupID) mThis.nonGroupedAccounts.push(account);
    });
  }

  /***************************************************************************
   * sortGroups */
  /**
   * Called after accounts are moved from one list to the other. Digest is
   * called to refresh the list in the DOM
   ***************************************************************************/
  function sortGroups(sourceID) {
    if (sourceID == 'non-grouped')
      mThis.acctsInGroup.sort(function (a, b) {
        return a.displayName
          .toLowerCase()
          .localeCompare(b.displayName.toLowerCase());
      });

    if (sourceID == 'in-group')
      mThis.nonGroupedAccounts.sort(function (a, b) {
        return a.displayName
          .toLowerCase()
          .localeCompare(b.displayName.toLowerCase());
      });

    $scope.$digest();
  }

  /*-----------------------------------------*/
  /* Shuttle service to move acounts between */
  /* the grouped and non grouped lists.      */
  /*-----------------------------------------*/
  ShuttleService.group('accounts').cmdHandler = function (
    cmd,
    source,
    target
  ) {
    if (source.id != target.id) {
      var sourceID = source.id;
      /*--------------------------------------------------*/
      /* Move the item on click or when the left or right */
      /* arrows are used along with the control key.      */
      /*--------------------------------------------------*/
      if (cmd.click) {
        cmd.handler.shuttleItem();
        sortGroups(sourceID);
      }

      /*-----------------------------------------*/
      /* If the left or right arrows are pressed */
      /* without the ctrl key, move the focus.   */
      /*-----------------------------------------*/
      if (
        (cmd.right && sourceID == 'non-grouped') ||
        (cmd.left && sourceID == 'in-group')
      )
        return cmd.ctrlKey
          ? (cmd.handler.shuttleItem(), sortGroups(sourceID))
          : cmd.handler.shuttleFocus(0);
    }

    /*---------------------------------------------------------*/
    /* Move the item or the cursor when the up and down arrows */
    /* are used, regardless of the target and source id's.     */
    /*---------------------------------------------------------*/
    if (cmd.vertical) return cmd.handler.moveFocus();

    /*--------------------------------------------------*/
    /* Allow items to be moved on dragging or dropping. */
    /*--------------------------------------------------*/
    if (cmd.dragStart) return cmd.handler.startDrag('move');
    if (cmd.dragOver) return cmd.handler.allowDrop('move');

    /*---------------------------------------------------*/
    /* Add the insert class when entering a new element. */
    /*---------------------------------------------------*/
    if (cmd.dragEnter) return !!cmd.dropElement.addClass('insert');

    /*-----------------------------------------*/
    /* Remove the insert class when an element */
    /* is dropped or it leaves the source.     */
    /*-----------------------------------------*/
    if (cmd.dragLeave || cmd.drop) {
      cmd.dropElement.removeClass('insert');

      if (cmd.drop) {
        cmd.event.preventDefault();
        cmd.handler.drop(-1);
        removeInsertClass();
        sortGroups(sourceID);
      }

      return true;
    }
  };

  mThis.$onInit = function () {
    BusyScreen.promise($q.all([AccountSettings.accounts, setAccountInfo()]));
  };
}
